export default __webpack_public_path__ + "static/media/customer.e3be6c13.png";